import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
const Order = () => {
    const [order, setOrder] = React.useState([])
    const [allorder, setAllOrder] = React.useState([]);
     const [search, setSearch] = useState("");
    // const [currentStatus, setCurrentStatus] = React.useState("Processing");
    // const [scount, setScount] = React.useState(0);
    const notify = (text) => toast(text, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
    const loadOrderList = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_SERVER_URL + '/orders/getAllOrder', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
            const data = await response.json()
            console.log(data)
            setOrder(data.orders)
        }
        catch (err) {
            console.log(err)
        }
    }
    const cancleOrder = (id) => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + `/orders/changeStatus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`

                },
                body: JSON.stringify({ id, status: 'Cancelled' })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    // loadData()
                    notify(data.message);
                    loadOrderList()
                }
                ).catch(err => notify(err))
        } catch (error) {
            console.log(error)
        }
    }

    const toggleStatus = (id, status) => {
        var newStatus = "";
        if (status === 'Processing') {
            newStatus = 'Shipped'
        }
        else if (status === 'Shipped') {
            newStatus = 'Delivered'
        } else {
            return;
        }
        try {
            fetch(process.env.REACT_APP_SERVER_URL + `/orders/changeStatus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ id, status: newStatus })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    // loadData()
                    notify(data.message);
                    loadOrderList()
                }
                ).catch(err => notify(err))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
      setAllOrder(order);
      if (search !== "") {
        let filteredBuyers = order.filter((item) =>
         item._id.toLowerCase().includes(search.toLowerCase())
        );
        setAllOrder(filteredBuyers);
        //  loadOrderList();
      } else {
        setAllOrder(order);
        //  loadOrderList();
      }
    }, [search, order]);

    React.useEffect(() => {
        loadOrderList()
    }, [])

    return (
      <div>
        <Navbar />
        <div
          className="text-3xl w-full font-bold bg-gradient-to-l from-green-200 to-green-500 "
          style={{ textAlign: "center" }}
        >
          <p className="pt-2">Orders</p>
         
        </div>
        <h3 className='w-full text-center'>Total Order : {order.length}</h3>
        <div className=" flex flex-row items-center">
          <div className="m-2 mt-8 bg-slate-500 px-3 py-1 text-green-400 rounded-2xl font-bold">
            Search
          </div>
          <input
            type="text"
            placeholder="             Order Id"
            className="mt-5 ml-3 dark:bg-black dark:text-white bg-gray-200 border border-gray-400 rounded-2xl py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
        <section className="min-h-screen">
          <div className="overflow-x-auto relative shadow-md sm:rounded-lg text-center">
            <table className="w-full text-sm  text-gray-500 dark:text-gray-400 container mx-auto mt-10 text-center">
              <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:text-gray-400">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    Order Number
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Order Date
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Total Amount
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Order Items
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Address
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Mode of Payment
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Status
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Cancel Shipment
                  </th>
                </tr>
              </thead>
              <tbody className="m-auto">
                {allorder.length > 0 ? (
                  allorder.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                      >
                        <td className="py-4 px-6">{item["_id"]}0</td>
                        <td className="py-4 px-6">{item["order_date"]}</td>
                        <td className="py-4 px-6">{item["total"]}</td>
                        <td className="py-4 px-6">{item.products.length}</td>
                        <td className="py-4 px-6 ">
                          <p className="truncate w-16">{item["address"]}</p>
                        </td>
                        <td className="py-4 px-6">{item["paymentMethod"]}</td>
                        <td className="py-4 px-6">
                          {/* select option */}
                          <button
                            onClick={() => {
                              toggleStatus(item["_id"], item["status"]);
                            }}
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            {item.status === "Delivered" ? (
                              <span className="text-green-600">
                                {item.status}
                              </span>
                            ) : (
                              <span>{item.status}</span>
                            )}
                          </button>
                        </td>
                        <td className="py-4 px-6  ">
                          <button
                            onClick={() => {
                              if (item.status !== "Cancelled")
                                cancleOrder(item._id);
                            }}
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                          >
                            Cancel
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
        <Footer />
      </div>
    );
}

export default Order